import {useState} from 'react';
import AttendanceWorkspace from '../../components/attendance/AttendanceWorkspace';
import { attendanceText, japanDate } from '../../components/attendance/attendanceI18n';
import DriverBrandHeader from './DriverBrandHeader';
import { DriverAPI } from './config';
import './DriverAttendance.css';
export default function DriverAttendance({enabled,language,driverName='',request=DriverAPI.attendanceRequest,wagesEnabled=true,expensesEnabled=true,brandName='BIG TAXI',logoSrc}) {
 const [month,setMonth]=useState(japanDate().slice(0,7));
 if(!enabled)return null;
 const locale=language==='ja'?'ja-JP':language==='en'?'en-US':'zh-CN';
 const monthLabel=new Intl.DateTimeFormat(locale,{year:'numeric',month:'long'}).format(new Date(`${month}-01T12:00:00`));
 return <section className="driver-attendance-theme"><DriverBrandHeader brandName={brandName} {...(logoSrc?{logoSrc}:{})} pageTitle={attendanceText(language).title} driverName={driverName} subtitle={monthLabel}/><AttendanceWorkspace request={request} wagesEnabled={wagesEnabled} expensesEnabled={expensesEnabled} language={language} onMonthChange={setMonth}/></section>;
}
